import { TableColumn } from "react-data-table-component";
import { IConfig, IUser } from "src/services/types";
import { X, Check, Eye} from 'feather-icons-react';
// import { DropdownActionsUser } from "../Users/DropdownActionsUser";
import { UserColumnItem } from "../Users/UserColumnItem";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { Trash2, CornerUpLeft, MoreVertical, CornerUpRight, ArrowRight, MessageSquare, Edit2 } from 'feather-icons-react';

export const ColumnsUsersByGroups: (
    config: IConfig,
    onValidate: (item: IUser) => void,
    onReject: (item: IUser) => void,
    openModal: (item: IUser) => void,
    onDelete: (item: IUser) => void,
    onMoveAGroup: (item: IUser) => void,
    openNoteModal: (item: IUser) => void,
    openEditUserModal: (item: IUser) => void,
    onReturnToReview: (item: IUser) => void
) => TableColumn<IUser>[] = 
(config, onValidate, onReject, openModal, onDelete, onMoveAGroup, openNoteModal, openEditUserModal, onReturnToReview) => {
      
    return (
[
    { 
      name: "N°",
      width: "80px",
      center: true,
      selector: (_, index, ) => (config.page-1)*config.per_page + (index! + 1),
    },
    {
      name: "USER",
      width: "230px",
      cell: function OrderItems(item) {
        return (
          <UserColumnItem
            item={item}
            openModal={openModal}
            openNoteModal={openNoteModal}
          />
        );
      }
    },
    {
      name: "EMAIL",
      width: "300px",
      selector: (row: IUser) => row.email,
    },
    {
      name: "GROUP",
      width: "200px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <>
            {
              item?.group ? (
                <small
                    className="p-2 rounded"
                    style={{ backgroundColor: item?.group?.color || '#f5f5f5'}}
                >
                  <span>{item?.group?.name ? (item.group.name.length > 20 ? item.group.name.slice(0, 19) + '...' : item.group.name) : '-'}</span>
                </small>
              ) : '-'
            }
          </>
        );
      },
    },
    {
      name: "VERIFIED BY ADMIN",
      center: true,
      width: "150px",
      cell: function OrderItems(item) {
        return (
            <div
                className="px-3"
                style={{
                  height: '30px',
                  borderRadius: '5px',
                  backgroundColor: item?.isVerifiedByAdmin === null ? '#f0f0f0' : item?.isVerifiedByAdmin ? '#eef8f3' : '#fff1f0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
            >
              {
                item?.isVerifiedByAdmin === null ?
                <span className="text-secondary">Pending</span> :
                item?.isVerifiedByAdmin ?
                <span className="text-success">Validated</span> :
                <span className="text-danger">Rejected</span>
              }
            </div>
        );
      },
    },
    {
      name: "OPTIONS",
      width: "100px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <UncontrolledDropdown
              className="me-2"
              direction="start"
          >
            <DropdownToggle
            caret
            className="btn btn-soft-info btn-sm waves-effect waves-light"
            >
            <MoreVertical size={'16px'}/>
            </DropdownToggle>
            <DropdownMenu>
                <DropdownItem onClick={() => openNoteModal(item)}>
                    <div className="d-flex align-items-center gap-2">
                      <MessageSquare size="16"/>
                      <span>
                        {item?.note ? 'View/Edit note' : 'Add note'}
                      </span>
                    </div>
                </DropdownItem>
                <DropdownItem divider style={{margin: '5px'}}/>
                <DropdownItem onClick={() => onMoveAGroup(item)}>
                    <div className="d-flex align-items-center gap-2">
                    {item?.group?.id ? <ArrowRight size="16"/> : <CornerUpRight size="16" />}
                    <span>{item?.group?.id ? 'Change/remove group' : 'Assign group'}</span>
                    </div>
                </DropdownItem>
                {
                  item?.isVerifiedByAdmin !== true && (
                    <>
                      <DropdownItem divider style={{margin: '5px'}}/>
                      <DropdownItem onClick={() => onValidate(item)}>
                          <div className="d-flex align-items-center gap-2">
                            <Check size="16"/>
                            <span>Validate user</span>
                          </div>
                      </DropdownItem>
                    </>
                  )
                }
                {
                  item?.isVerifiedByAdmin === null && (
                    <>
                      <DropdownItem divider style={{margin: '5px'}}/>
                      <DropdownItem onClick={() => onReject(item)}>
                          <div className="d-flex align-items-center gap-2">
                            <X size="16"/>
                            <span>Rejected user</span>
                          </div>
                      </DropdownItem>
                    </>
                  )
                }
                {
                  item?.isVerifiedByAdmin == false && (
                    <>
                      <DropdownItem divider style={{margin: '5px'}}/>
                      <DropdownItem onClick={() => onReturnToReview(item)}>
                          <div className="d-flex align-items-center gap-2">
                            <CornerUpLeft size="16"/>
                            <span>Return to review</span>
                          </div>
                      </DropdownItem>
                    </>
                  )
                }
              <DropdownItem divider style={{margin: '5px'}}/>
              <DropdownItem onClick={() => onDelete(item)}>
                  <div className="d-flex align-items-center gap-2">
                  <Trash2 size="16"/>
                  <span>Delete user</span>
                  </div>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        )
      }
    }
  ]
)}